export const CONDITIONS = Object.freeze({
  clearSkies: Object.freeze({
    key: 'clear-skies',
    icon: '⛵',
    name: 'Clear Skies',
    schedule: 'Monday–Wednesday',
    description: 'An obvious forced first move opens a puzzle solved with direct deductions throughout.',
  }),
  rollingSwells: Object.freeze({
    key: 'rolling-swells',
    icon: '💨',
    name: 'Rolling Swells',
    schedule: 'Thursday–Friday',
    description: 'An obvious forced first move opens a puzzle that rewards looking ahead later on.',
  }),
  deepShroud: Object.freeze({
    key: 'deep-shroud',
    icon: '🌫️',
    name: 'Deep Shroud',
    schedule: 'Saturday–Sunday',
    description: 'An obvious forced first move opens a puzzle that may soon require deeper look-ahead or a trial with Undo.',
  }),
});

// Local first-pass testing intentionally remains on Clear Skies on every day.
export const DEFAULT_CONDITION = CONDITIONS.clearSkies;
